import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface RateLimitState {
  isRateLimited: boolean;
  retryAfterTimestamp: number | null; // Unix timestamp when rate limit expires
  affectedEndpoint: string | null;
  limitInfo: {
    limit: number;
    window: string;
  } | null;
}

const initialState: RateLimitState = {
  isRateLimited: false,
  retryAfterTimestamp: null,
  affectedEndpoint: null,
  limitInfo: null,
};

interface SetRateLimitedPayload {
  retryAfter: number; // seconds until retry allowed
  endpoint: string;
  limit?: number;
  window?: string;
}

const rateLimitSlice = createSlice({
  name: 'rateLimit',
  initialState,
  reducers: {
    setRateLimited: (state, action: PayloadAction<SetRateLimitedPayload>) => {
      const { retryAfter, endpoint, limit, window } = action.payload;
      state.isRateLimited = true;
      state.retryAfterTimestamp = Date.now() + retryAfter * 1000;
      state.affectedEndpoint = endpoint;
      if (limit && window) {
        state.limitInfo = { limit, window };
      }
    },
    clearRateLimited: (state) => {
      state.isRateLimited = false;
      state.retryAfterTimestamp = null;
      state.affectedEndpoint = null;
      state.limitInfo = null;
    },
  },
});

export const { setRateLimited, clearRateLimited } = rateLimitSlice.actions;

export default rateLimitSlice.reducer;
